import React from 'react'
// import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function OilGas() {
    // const [active, setActive] = useState("Safe Area");
    // const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        Oil & Gas Electrical & Instrumentation Solutions UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides electrical and instrumentation bulk solutions for upstream, midstream and downstream oil & gas applications in the UAE, including cables, cable glands, MCT, junction boxes, lighting, valves, tubing and hazardous area products."
    />

    <meta
        name="keywords"
        content="oil and gas electrical solutions UAE, oil and gas instrumentation UAE, electrical bulk oil gas UAE, instrumentation bulk UAE, hazardous area electrical products UAE, oil gas cable glands UAE, MCT UAE, oil gas junction boxes UAE, instrumentation cables UAE, instrumentation tubing UAE, instrumentation valves UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/oilgas"
    />

    <meta
        property="og:title"
        content="Oil & Gas Electrical & Instrumentation Solutions UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Comprehensive electrical and instrumentation solutions for upstream, midstream and downstream oil & gas applications across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/oilgas"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Oil & Gas</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Driving innovation and efficiency in energy exploration and delivery.
                    </p>
                </div>
            </div>
          


                <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Oil & Gas</h2>
  <div className='line'></div>
                         <h3 className='text-left'>We work with world’s leading specialist manufacture’s whose products are specified and in use on all three groups of industries – upstream, downstream and midstream.
<br/><br/>We specialise and provide comprehensive solution for the supply of Electrical & Instrumentation Bulk – matching performance & safety for hazardous area and industrial applications.

</h3>

               </div>
               </div>
            <section className='lg:pt-[10px] pt-[10px] lg:pb-[0px] pb-[20px]'>
             
                <div className="grid lg:grid-cols-2 grid-cols-1 pb-[36px] lg:gap-[90px] gap-[30px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                   <div className="lg:sticky lg:top-[100px] self-start">
    <div className="h-[auto] mb-[15px] w-full justify-center flex items-center rounded-[12px] p-[22px]">
      <img
        src="/assets/saigel.png"
        className="rounded-[12px]"
        alt="Trusted cable management and termination solutions provider in the UAE"
      />
    </div>
  </div>
                 
                         <div className="service-details-div2 font-kanit service-details-div2-new">
                        <h6 className="font-[500] font-kanit lg:text-[35px] text-[26px] lg:leading-[62.4px] leading-[32px] text-[#000000] ">Electrical  Bulk</h6>
                    
                      {/* ITEM */}
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Cables </h4>
                      </div>
                      <p>
                      Our offering includes power, earthing and control to low and medium voltage designed to BS, EN, IEC, IEEE and marine specs CSA/UL/CE (CENELEC) standards </p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>
Cable Glands/Terminations</h4>
                      </div>
                      <p>
                      The range includes industrial, hazardous, barrier and EMC glands in all metallurgy</p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Cable Tray and Support Systems </h4>
                      </div>
                      <p>
                     We offer tailored cable trays, cable ladders and channel support system in HDG, stainless steel and aluminium. This system includes full range of fixings and accessories including bends and risers. </p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Lighting</h4>
                      </div>
                      <p>
                     LED, HID, flood, fluorescent, incandescent, marine and emergency lighting constitutes our lighting range for safe, hazardous and harsh environments. Accessories like junction box, light poles, sunshades, mounting brackets, fall safe wire rope arrangements can be undertaken by us to offer a complete solution. </p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Local Control Station</h4>
                      </div>
                      <p>
                       Up to 81 operating elements can be made available for efficient operation and monitoring of multiple circuits and machinery in hazardous areas in Aluminium, Stainless Steel and GRP
                      </p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Socket Outlets</h4>
                      </div>
                      <p>
                      We offer a wide range of industrial socket outlets (16A to 600A), ATEX socket outlets, switch-disconnectors to meet various safety issues in industrial environments.
                      </p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Signalling Devices </h4>
                      </div>
                      <p>
                       The offering covers audible, visual, combination devices, call points and grounding systems made from corrosion resistant aluminium or GRP for the usage in gas and dust explosion-hazardous areas.
                      </p>
                       <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Earthing & Lightning Materials  </h4>
                      </div>
                      <p>
                     The range covers early warning systems, early streamer emission, air terminals, down conductors, earthing and exothermic welding products </p>
                       <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Electrical Accessories </h4>
                      </div>
                      <p>
                      We carry lugs, connectors, grounding, cable tie wraps, labelling materials, tapes, terminals, adhesives, fasteners and more. This helps and support you to quickly and reliably connect, label and secure your electrical wiring. </p>
                    
                    
                    </div>
                </div>
              
            </section>



        <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>

                         <h3 className='text-left'>

Our supplies are offered using services and technical support of approved manufacturers like MESC,
Ramcro, Shawflex, Südkabel, Hawke, BICC, YK Electric, Zalux, Chalmit, Unistrut, Furse, Marechal,
Cembre, Weidmuller, Pepperl+Fuchs, Eaton, MEDC, Tubacex, Hoke Gryolok, HTS, etc.</h3>



               </div>
               </div> 
            
 <section className='lg:pt-[50px] pt-[30px] lg:pb-[0px] pb-[0px]'>
             
                <div className="grid lg:grid-cols-2 grid-cols-1 pb-[36px] lg:gap-[90px] gap-[30px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                   <div className="lg:sticky lg:top-[100px] self-start">
    <div className="h-[auto]  mb-[15px] w-full justify-center flex items-center rounded-[12px] p-[22px]">
      <img
        src="/assets/saigin.png"
        className="rounded-[12px]"
        alt="Trusted cable management and termination solutions provider in the UAE"
      />
    </div>
  </div>
  

   <div className="service-details-div2 font-kanit service-details-div2-new">
  <h6 className="font-[500] font-kanit lg:text-[35px] text-[26px] lg:leading-[62.4px] leading-[32px] text-[#000000] ">
    Instrumentation Bulk
  </h6>

  {/* Cable Glands & MCT */}
   <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cables</h4>
  </div>
  <p>
  Our offering includes instrumentation (Single/Multi Pair/Triad/Quad – IS/OS),
control (up to 61Core) and signalling cables as per UL, IEC, BS, EN, DIN, ANSI and
VDE standards. Specialized cables for applications such as Thermocouple Extension,
Fibre optics, Foundation Field Bus, Co-Axial, LAN are also available as per
international standards.
  </p>
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cable Glands & MCT</h4>
  </div>
  <p>
    The range includes industrial, hazardous, barrier and EMC glands in all metallurgy. 
    MCT is available in welded and bolted options.
  </p>

  {/* Cable Tray */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cable Tray and Support Systems</h4>
  </div>
  <p>
    We offer tailored cable trays, cable ladders and channel support system in HDG, stainless steel and aluminium. 
    This system includes full range of fixings and accessories including bends and risers.
  </p>

  {/* Junction Box */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Junction Box</h4>
  </div>
  <p>
    The junction box range includes SS316L, aluminium and GRP with ATEX and/or IECEx standards.
  </p>

  {/* Tubing */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Tubing's and Fittings</h4>
  </div>
  <p>
    A wide variety of instrumentation fittings for tube attachments to transfer, measure and control system flow, pressure, temperature and provide system calibration are available in various metallurgy with latest NACE certification, including accessories viz. tube clamps, racks, hangers etc.
  </p>

  {/* Valves */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Valves & Air Headers</h4>
  </div>
  <p>
    A comprehensive range of Ball Valves, Bleed Valves, Needle Valves, Manifolds are available in SS316/316L grade with NACE certification to provide controlled isolation and connection to regulate the flow of gasses, liquids and other loose materials through the piping system
  </p>

  {/* Hose */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Hose Assemblies</h4>
  </div>
  <p>
    The offer includes a wide spectrum of hose assemblies in Rubber, Thermoplastic, Stainless Steel etc. to meet the demanding compressed gas and industrial applications
  </p>

  {/* Stanchion */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Stanchion & Sunshades</h4>
  </div>
  <p>
    Stanchions for junction box, signalling devices, gas detectors are available as per the customer request. Instrument Enclosures & Sunshades in GRP and SS316 with different mounting options can be made available.
  </p>

  {/* Accessories */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Accessories</h4>
  </div>
  <p>
    We carry label printers, labelling materials, terminal connectors, sleeves, cable cleats, cable tie wraps, tapes, adhesives, fasteners and more. This helps and support you to quickly and reliably connect, label and secure your electrical wiring.
  </p>

  <Link to="/industries">
    <button className="backbtn">Back To Industries</button>
  </Link>
</div>

                  
                </div>
              
            </section>

    {/* <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[50px]'>

                         <h3 className='text-left'>

Our knowledgeable staff can help you find the perfect products for your needs, so that you can rely on us to provide support through every stage of the project. The range is so vast that listing all the articles is impossible - please contact us for unlisted products.
To ensure logistics we have tied with established freight forwarders undertaking Airfreights, FCL, LCL and chartered loads - ensuring totality!</h3>



               </div>
               </div>  */}



            {/* <section className='service-section lg:pt-[100px] pt-[60px] lg:pb-[92px] pb-[60px] lg:px-0 px-[20px]'>
                <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] tracking-[0.2px] text-[#0E2A62] pb-[24px] text-center">What We Stand For</h6>
                <p className="font-[300] font-kanit text-[17px] leading-[27px] text-center text-[#49577A] lg:pb-[62px] pb-[30px]">We are the partner you need to gain an edge over your competitors. Here’s what sets us apart.</p>

                <div className="flex lg:gap-[180px] gap-[40px] justify-center items-center lg:flex-row flex-col">
                    <div>
                        <img src="/assets/service/img4.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                    </div>
                    <div className='max-w-[459px] w-full'>
                        <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] text-[#000000] pb-[27px]">Tailored, Growth Driven Cloud Solutions</h6>
                        <p className="font-[300] font-kanit text-[17px] leading-[20px] text-[#49577A]">Mobikode’s cloud engineering services have been designed to offer mission-critical solutions to organizations with diverse needs, scale and scope. Our cloud engineering experts bring expertise and experience to the table and the ethos of sharing intellectual capital to equip our clients with unambiguous insights into their transition to the cloud.</p>
                    </div>
                </div>
            </section> */}
            {/* <section style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }} className='lg:px-[100px] px-[20px]'>
                <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] text-[#000000] lg:pb-[80px] pb-[40px]">Product Recommendation</h6>
                <div className="grid lg:grid-cols-3 grid-cols-2 lg:gap-[36px] gap-[20px] lg:pb-[142px] pb-[80px]">
                    <div>
                        <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                            <img src="/assets/product/img1.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                            <button onClick={() => navigate('/product/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                View Details
                            </button>
                        </div>
                        <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                            junction box & enclosures
                        </h6>
                        <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                            Polymer & Sheet Metal
                        </p>
                    </div>
                    <div>
                        <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                            <img src="/assets/product/img2.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                            <button onClick={() => navigate('/product/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                View Details
                            </button>
                        </div>
                        <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                            re-enterable gel 7 fillers
                        </h6>
                        <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                            Re-usable & Cast
                        </p>
                    </div>
                    <div>
                        <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                            <img src="/assets/product/img3.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                            <button onClick={() => navigate('/product/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                View Details
                            </button>
                        </div>
                        <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                            Cables
                        </h6>
                        <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                            Power & Instrumentation
                        </p>
                    </div>
                </div>
            </section> */}
        </>
    )
}

export default OilGas